import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const ResponsibleTotalContent = ({data, boName}) => {

    useEffect(() => {
        const values = [];
        const labels = [];

        data.responsibleBo.forEach((element) => {
            labels.push(ReportUtils.formatText(element.responsible));
            values.push(element.total_bos);
        });

        GraphicUtils.barChart("responsibleBoTotal", values.slice(0, 10), labels.slice(0, 10), false);
        ReportUtils.createExportableTable(labels, values, 'Total por responsável')
    }, [data]);

    return (
        <>
            <div className="chart mt-3">
                <span className="chart-title">
                    Total de {boName} por responsável {data.responsibleBo.length >= 10 ? ' (TOP 10)' : ''}
                </span>

                <div id="responsibleBoTotal"></div>
            </div>

            <div className="chart-divisor print-hide"></div>
        </>
    );
};

export default ResponsibleTotalContent;